"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_NPC_TICK_SAFETY_LIMITS = void 0;
exports.defaultNpcTickLog = defaultNpcTickLog;
/** Applied to every new `GameEngine` until overridden via `setNpcTickSafetyLimits`. */
exports.DEFAULT_NPC_TICK_SAFETY_LIMITS = {
    /** Enough for large co-op casts; stops pathological NPC counts in one tick. */
    maxNpcsPerTick: 32,
    /** Keeps a single tick from blocking the host/event loop too long (~5–10 NPCs @ ~20ms each). */
    maxWallTimeMsPerTick: 200
};
function defaultNpcTickLog(level, message, meta) {
    const line = meta && Object.keys(meta).length > 0 ? `${message} ${JSON.stringify(meta)}` : message;
    if (level === 'debug' && typeof console.debug === 'function') {
        console.debug(`[NPC tick] ${line}`);
    }
    else if (level === 'warn' && typeof console.warn === 'function') {
        console.warn(`[NPC tick] ${line}`);
    }
    else if (typeof console.error === 'function') {
        console.error(`[NPC tick] ${line}`);
    }
}
//# sourceMappingURL=npcTickConfig.js.map